import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private readonly TOKEN_KEY = 'auth_token';
  private readonly REFRESH_TOKEN_KEY = 'refresh_token';

  private readonly STORAGE = sessionStorage;

  setToken(token: string): void {
    this.STORAGE.setItem(this.TOKEN_KEY, token);
  }

  getToken(): string | null {
    return this.STORAGE.getItem(this.TOKEN_KEY);
  }

  clearToken(): void {
    this.STORAGE.removeItem(this.TOKEN_KEY);
  }

  hasToken(): boolean {
    const token = this.getToken();
    return !!token && !this.isTokenExpired();
  }
  setRefreshToken(refreshToken: string): void {
    this.STORAGE.setItem(this.REFRESH_TOKEN_KEY, refreshToken);
  }

  getRefreshToken(): string | null {
    return this.STORAGE.getItem(this.REFRESH_TOKEN_KEY);
  }

  clearRefreshToken(): void {
    this.STORAGE.removeItem(this.REFRESH_TOKEN_KEY);
  }

  clearAuthData(): void {
    this.clearToken();
    this.clearRefreshToken();
  }

  /**  Check if the stored token is expired.*/
  isTokenExpired(): boolean {
    const token = this.getToken();
    if (!token) return true;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const expiry = payload.exp * 1000;
      return Date.now() > expiry;
    } catch {
      return true;
    }
  }
}
